import React, { Children } from 'react';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-320">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-321">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-322">
          Privacy & Cookie Policy
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6" data-id="element-323">
          <div data-id="element-324">
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-325">
              <strong data-id="element-326">Last updated:</strong>{' '}
              {new Date().toLocaleDateString('en-GB', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-327">
              At Domisafe, we are committed to protecting your privacy and
              handling your personal data responsibly. This Privacy & Cookie
              Policy explains what information we collect, how we use it, and
              your rights under UK data protection law, including the General
              Data Protection Regulation (GDPR).
            </p>
          </div>

          <div data-id="element-328">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-329">
              1. Information We Collect
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-330">
              When you use Domisafe, we collect the following types of
              information:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-331">
              <li data-id="element-332">
                <strong data-id="element-333">Personal Information:</strong> Your name, email address,
                and any other details you provide when creating an account or
                contacting us
              </li>
              <li data-id="element-334">
                <strong data-id="element-335">Usage Information:</strong> Data about how you use our
                platform, including features accessed, tasks created, and time
                spent on the service
              </li>
              <li data-id="element-336">
                <strong data-id="element-337">Technical Information:</strong> Your IP address, browser
                type, device information, and operating system
              </li>
              <li data-id="element-338">
                <strong data-id="element-339">Customer Information:</strong> Any customer records or
                business data you store within the Domisafe platform
              </li>
            </ul>
          </div>

          <div data-id="element-340">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-341">
              2. How We Use Your Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-342">
              We use the information we collect for the following purposes:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-343">
              <li data-id="element-344">
                <strong data-id="element-345">Operating the Service:</strong> To provide, maintain,
                and improve Domisafe, including processing your requests and
                managing your account
              </li>
              <li data-id="element-346">
                <strong data-id="element-347">Communication:</strong> To send you service updates,
                technical notices, security alerts, and respond to your
                enquiries
              </li>
              <li data-id="element-348">
                <strong data-id="element-349">Performance Monitoring:</strong> To analyse how our
                service is used and identify areas for improvement
              </li>
              <li data-id="element-350">
                <strong data-id="element-351">Security:</strong> To detect, prevent, and address
                technical issues, fraud, or security threats
              </li>
              <li data-id="element-352">
                <strong data-id="element-353">Legal Compliance:</strong> To comply with applicable
                laws, regulations, and legal processes
              </li>
            </ul>
          </div>

          <div data-id="element-354">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-355">
              3. Cookies and Similar Technologies
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-356">
              Domisafe uses cookies and similar technologies to support
              performance and enhance your user experience. Cookies are small
              text files stored on your device that help us:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600 mb-4" data-id="element-357">
              <li data-id="element-358">Remember your login details and preferences</li>
              <li data-id="element-359">Understand how you interact with our platform</li>
              <li data-id="element-360">Improve the speed and functionality of our service</li>
              <li data-id="element-361">Provide a more personalised experience</li>
            </ul>
            <p className="text-slate-600 leading-relaxed" data-id="element-362">
              You can control cookies through your browser settings. However,
              disabling cookies may affect the functionality of Domisafe. We use
              both session cookies (which expire when you close your browser)
              and persistent cookies (which remain on your device for a set
              period).
            </p>
          </div>

          <div data-id="element-363">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-364">
              4. Data Sharing and Disclosure
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-365">
              We do not sell, rent, or trade your personal information. We may
              share your data only in the following circumstances:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-366">
              <li data-id="element-367">
                <strong data-id="element-368">Service Providers:</strong> With trusted third-party
                providers who assist us in operating our service (e.g., hosting,
                payment processing), under strict confidentiality agreements
              </li>
              <li data-id="element-369">
                <strong data-id="element-370">Legal Requirements:</strong> If required by law, court
                order, or government regulation
              </li>
              <li data-id="element-371">
                <strong data-id="element-372">Business Transfers:</strong> In the event of a merger,
                acquisition, or sale of assets, your data may be transferred to
                the new entity
              </li>
              <li data-id="element-373">
                <strong data-id="element-374">With Your Consent:</strong> When you explicitly
                authorise us to share your information
              </li>
            </ul>
          </div>

          <div data-id="element-375">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-376">
              5. Data Security
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-377">
              We implement industry-standard security measures to protect your
              personal information from unauthorised access, disclosure,
              alteration, or destruction. This includes encryption, secure
              servers, regular security audits, and access controls. However, no
              method of transmission over the internet is 100% secure, and we
              cannot guarantee absolute security.
            </p>
          </div>

          <div data-id="element-378">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-379">
              6. Data Retention
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-380">
              We retain your personal information for as long as necessary to
              provide our service and comply with legal obligations. When you
              cancel your subscription, we may retain certain data for a limited
              period for backup, legal, or regulatory purposes. You may request
              deletion of your data at any time (see "Your Rights" below).
            </p>
          </div>

          <div data-id="element-381">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-382">
              7. Your Rights Under GDPR
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-383">
              Under UK data protection law, you have the following rights:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-384">
              <li data-id="element-385">
                <strong data-id="element-386">Right to Access:</strong> Request a copy of the personal
                data we hold about you
              </li>
              <li data-id="element-387">
                <strong data-id="element-388">Right to Rectification:</strong> Request correction of
                inaccurate or incomplete data
              </li>
              <li data-id="element-389">
                <strong data-id="element-390">Right to Erasure:</strong> Request deletion of your
                personal data (subject to legal obligations)
              </li>
              <li data-id="element-391">
                <strong data-id="element-392">Right to Restrict Processing:</strong> Request that we
                limit how we use your data
              </li>
              <li data-id="element-393">
                <strong data-id="element-394">Right to Data Portability:</strong> Request a copy of
                your data in a structured, machine-readable format
              </li>
              <li data-id="element-395">
                <strong data-id="element-396">Right to Object:</strong> Object to our processing of
                your data in certain circumstances
              </li>
              <li data-id="element-397">
                <strong data-id="element-398">Right to Withdraw Consent:</strong> Withdraw consent for
                data processing at any time
              </li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4" data-id="element-399">
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:hubtut84@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-400">
                hubtut84@gmail.com
              </a>
              . We will respond to your request within one month.
            </p>
          </div>

          <div data-id="element-401">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-402">
              8. International Data Transfers
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-403">
              Your data is primarily stored and processed within the UK. If we
              transfer data outside the UK or European Economic Area (EEA), we
              ensure appropriate safeguards are in place to protect your
              information in accordance with GDPR requirements.
            </p>
          </div>

          <div data-id="element-404">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-405">
              9. Children's Privacy
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-406">
              Domisafe is not intended for use by individuals under the age of
              18. We do not knowingly collect personal information from
              children. If we become aware that we have collected data from a
              child, we will take steps to delete it promptly.
            </p>
          </div>

          <div data-id="element-407">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-408">
              10. Changes to This Policy
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-409">
              We may update this Privacy & Cookie Policy from time to time to
              reflect changes in our practices or legal requirements. We will
              notify you of any significant changes by email or through a notice
              on our platform. Your continued use of Domisafe after such changes
              constitutes acceptance of the updated policy.
            </p>
          </div>

          <div data-id="element-410">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-411">
              11. Contact Us
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-412">
              If you have any questions about this Privacy & Cookie Policy or
              how we handle your personal data, please contact us at:
            </p>
            <p className="text-slate-600 mt-4" data-id="element-413">
              <strong data-id="element-414">Email:</strong>{' '}
              <a href="mailto:hubtut84@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-415">
                hubtut84@gmail.com
              </a>
            </p>
          </div>

          <div className="bg-slate-50 rounded-lg p-6 mt-8" data-id="element-416">
            <p className="text-slate-700 leading-relaxed" data-id="element-417">
              <span className="font-semibold" data-id="element-418">Your privacy matters to us.</span>{' '}
              We are committed to transparency and protecting your personal
              information in accordance with UK data protection law.
            </p>
          </div>
        </div>
      </section>
    </div>;
}